module.exports = __webpack_public_path__ + "media/images/new_landing/case/johana-graf-d5e178528195f7d4a33cb3c7dfbefe00.png";